
























import { Component, Vue, Prop } from "vue-property-decorator";
import { ViewerContentDTO } from "@../../../src/Generated/ParticaAPI";
import { FormFieldProps, FormFieldRules, IFormField, EnumDTO } from "../../Models/Components.model";
import ButtonList from "@/Ui-Components/Common/Buttons/ButtonList.vue";
import ParticaBaseForm from "../Base/ParticaBaseForm.vue";


@Component(
	{
		name: "ViewerContentForm",
		components: { ButtonList }
	})
export default class ViewerContentForm extends ParticaBaseForm<ViewerContentDTO> {

	private viewerContentTypeconfig =
		{
			props: {					name: "viewerContentType",
				placeholder: "Viewer Content Type",
				label: "Viewer Content Type",
				required: true,
				disabled: true,
				values:
					[
						{ label: "template", value: "template" } as EnumDTO,
						{ label: "zeropage", value: "zeropage" } as EnumDTO,
						{ label: "search", value: "search" } as EnumDTO,
						{ label: "tableofcontents", value: "tableofcontents" } as EnumDTO,
					],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

	private contentconfig =
		{
			props: { name: "content", placeholder: "Enter content", label: "Configuration", } as FormFieldProps,
			rules: { required: true, max: 8000, min: 0, } as FormFieldRules
		} as IFormField;

	private versionconfig =
		{
			props: {
				name: "version",
				placeholder: "Version",
				label: "Content Version",
				required: true,
				disabled: true,
				values: [
					{ label: "Live", value: "live" } as EnumDTO,
					{ label: "Preview", value: "preview" } as EnumDTO,
					{ label: "blank", value: "blank" } as EnumDTO,
				],
			} as FormFieldProps,
			rules: { required: true, numeric: true } as FormFieldRules
		} as IFormField;

}
